import { useEffect, useMemo } from 'react'

import shrinkPhoto from '../../utils/shrinkPhoto'

import './style.css'

export const MAX_CARD_PHOTOS = 3

// Photos of the original recipe card, kept apart from the food photo.
// saved: [{ id, image }] already on the recipe. pending: files to upload on save.
const RecipeCardPhotos = ({ saved = [], pending = [], onAdd, onRemoveSaved, onRemovePending }) => {
  const pendingUrls = useMemo(() => pending.map((file) => URL.createObjectURL(file)), [pending])
  useEffect(() => () => pendingUrls.forEach((url) => URL.revokeObjectURL(url)), [pendingUrls])

  const room = MAX_CARD_PHOTOS - saved.length - pending.length

  const onPhotosChosen = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, Math.max(room, 0))
    e.target.value = ''
    if (files.length) {
      onAdd(await Promise.all(files.map(shrinkPhoto)))
    }
  }

  const photo = (key, src, onRemove, label) => (
    <div className="cardPhotoItem" key={key}>
      <a href={src} target="_blank" rel="noreferrer">
        <img className="cardPhotoImage" src={src} alt={label} />
      </a>
      <button
        type="button"
        className="cardPhotoRemove"
        aria-label={`Remove ${label.toLowerCase()}`}
        onClick={onRemove}
      >
        ×
      </button>
    </div>
  )

  return (
    <div className="cardPhotosWrap">
      <p className="formLabel">
        Original recipe card <span className="formLabelHint">Optional</span>
      </p>
      <p className="cardPhotosText">
        Keep the card, in the cook's own handwriting, with the recipe. Up to {MAX_CARD_PHOTOS}{' '}
        photos.
      </p>
      <div className="cardPhotosList">
        {saved.map(({ id, image }, index) =>
          photo(`saved-${id}`, image, () => onRemoveSaved(id), `Recipe card ${index + 1}`)
        )}
        {pendingUrls.map((url, index) =>
          photo(
            `pending-${index}`,
            url,
            () => onRemovePending(index),
            `Recipe card ${saved.length + index + 1}`
          )
        )}
        {room > 0 && (
          <>
            <input
              id="recipeCardPhotosInput"
              className="cardPhotosInput"
              type="file"
              accept="image/*"
              multiple
              onChange={onPhotosChosen}
            />
            <label className="cardPhotosAdd" htmlFor="recipeCardPhotosInput">
              <span aria-hidden="true">+</span>
              Add photo
            </label>
          </>
        )}
      </div>
    </div>
  )
}

export default RecipeCardPhotos
